export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

export const ROLE_HIERARCHY_WEIGHT: Record<string, number> = {
  "admin": 1,
  "admin-interno": 2,
  "manager": 3,
  "user": 4,
};

export function compareUsersByRoleHierarchy(
  a: { role?: string | null; name?: string | null; email?: string | null },
  b: { role?: string | null; name?: string | null; email?: string | null },
  direction: "asc" | "desc" = "asc"
): number {
  const weightA = ROLE_HIERARCHY_WEIGHT[a.role || "user"] ?? 99;
  const weightB = ROLE_HIERARCHY_WEIGHT[b.role || "user"] ?? 99;
  if (weightA !== weightB) {
    return direction === "asc" ? weightA - weightB : weightB - weightA;
  }
  const nameA = (a.name || a.email || "").toLowerCase();
  const nameB = (b.name || b.email || "").toLowerCase();
  return nameA.localeCompare(nameB);
}

